var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84518 17.9561C9.56872 17.9552 9.30503 17.8397 9.11704 17.6372L4.2694 12.4861C3.89205 12.0844 3.91214 11.4532 4.31428 11.0762C4.71643 10.6993 5.34833 10.7194 5.72569 11.1211L9.83521 15.4951L18.2238 6.32858C18.4558 6.04005 18.8287 5.9037 19.1923 5.97448C19.5559 6.04526 19.8503 6.31151 19.9569 6.66593C20.0634 7.02035 19.9645 7.40455 19.7001 7.66369L10.5833 17.6273C10.3971 17.8334 10.1331 17.9526 9.85516 17.9561H9.84518Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.aeb0dea216f9b7740af8937b01269a1a.svg";
export { ForwardRef as ReactComponent };